import React, { useEffect, useRef, useState } from "react"
import ReactDOM from "react-dom"
import { useDispatch, useSelector } from "react-redux"
import dayjs from "dayjs"
import { FaPhone } from "react-icons/fa"
import { LoadingOutlined } from "@ant-design/icons"
import {
  Checkbox,
  Col,
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  message,
  AutoComplete,
  InputNumber,
  notification
} from "antd"

// Components
import Button from "src/components/MyButton/Button"
import { FooterStyle } from "src/pages/ADMIN/HumanResource/Files/AddNewHr/styled"
import IconBase from "src/components/IconBase"
import Notice from "src/components/Notice"
import Calling from "./Calling"

// Utils
import HRService from "src/services/HumanResource"
import CRMService from "src/services/CRMService"
import { removeVietnameseTones } from "src/lib/stringsUtils"
import { INTENDED_USE } from "../index"
import { setListProvince } from "src/redux/hr"
import { updateStatus } from "src/redux/crm"
import STORAGE from "src/lib/storage"

// Styled
import {
  BlockInfoStyle,
  TextTileStyle,
} from "src/pages/ADMIN/HumanResource/styled"
import { FormItemStyle } from "../common/styled"
import { setInit } from "src/redux/crmCallingReducer"
import { BACKSEAT_BASE_AMOUNT_OPTIONS, CALL_STATE, CALL_TYPE, PROVIDER_OPTIONS } from "src/constants/constants"
import { applyTrainingVehiclePrice } from "src/lib/priceUtils"
import { useLocation } from "react-router-dom"
import PhoneInputForm from "../../../../../components/PhoneInputForm"
import { calculateBackseatPrice } from "src/lib/priceBackseat"

export const formatCurrency = value => {
  const rawValue = value.replace(/[^0-9]/g, "")
  return rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export const validateNoLettersOrSpecialChars = (_, value) => {
  const regex = /^[0-9,]+$/
  if (!value || regex.test(value)) {
    return Promise.resolve()
  }
  return Promise.reject("Chỉ được nhập số!")
}

export const formatAddress = text => {
  return text
    .toLowerCase()
    .replace(/(?:^|\s)\S/g, c => c.toUpperCase()) // viết hoa chữ cái đầu của mỗi từ
    .replace(/\s+/g, " ") // loại bỏ khoảng trắng thừa
    .trim()
}

export const EXPIRY_DATE = [
  { ID: 12, title: "1 năm" },
  { ID: 18, title: "1.5 năm" },
  { ID: 24, title: "2 năm" },
  { ID: 36, title: "3 năm" },
]

// Const
export const statusCall = [
  // { id: 1, name: "Có nhu cầu" },
  { id: 1, name: "Mới" },
  { id: 2, name: "Liên hệ sau" },
  { id: 3, name: "Chưa liên lạc được" },
  { id: 4, name: "Chốt đơn" },
  { id: 5, name: "Không mua" },
  { id: 6, name: "Giảm phí" },
  // { id: 6, name: "Tái tục" },
]

export const gifts = [
  { ID: 1, title: "Tinh dầu" },
  { ID: 2, title: "Ví da" },
]

const options = [
  { value: 'Dưới 3 tấn', label: 'Dưới 3 tấn' },
  { value: 'Từ 3 đến 8 tấn', label: 'Từ 3 đến 8 tấn' },
  { value: 'Từ 8 đến 15 tấn', label: 'Từ 8 đến 15 tấn' },
  { value: 'Trên 15 tấn', label: 'Trên 15 tấn' },
];
export const maskPhoneNumber = phoneNumber => {
  return phoneNumber.slice(0, 2) + "******" + phoneNumber.slice(-2)
}

const ContactCustomer = props => {
  const {
    onCancel,
    contactId,
    getListContact,
    isComponentVisible,
    setIsComponentVisible,
    type,
    isCalling,
  } = props
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""

  const dispatch = useDispatch()
  const { callState } = useSelector(state => state.calling)

  const [dataContact, setDataContact] = useState({})
  const [statusResult, setStatusResult] = useState(1)
  const [isLoading, setIsLoading] = useState(false)
  const [isPrioritize, setIsPrioritize] = useState(false)
  const [isFetchedPrioritize, setIsFetchedPrioritize] = useState(false)
  const [cars, setCars] = useState([])

  const { listProvince } = useSelector(state => state.hr)
  const [district, setDistrict] = useState([])
  const [ward, setWard] = useState([])

  const [form] = Form.useForm()
  const [orderForm] = Form.useForm()

  const shippingDataRef = useRef(null)
  const callingContainerRef = useRef(null)
  const [giftList, setGiftList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [showSelect, setShowSelect] = useState(false);
  const [isPayloadDisabled, setIsPayloadDisabled] = useState(false);
  const [isEndowCalculated, setIsEndowCalculated] = useState(false);
  const [isHddt, setIsHddt] = useState(false);

  useEffect(() => {
    // Gọi API để lấy danh sách quà tặng
    const fetchGiftList = async () => {
      const cachedGifts = sessionStorage.getItem('giftList');
      if (cachedGifts) {
        setGiftList(JSON.parse(cachedGifts));
      } else {
        try {
          const res = await HRService.getListGift();
          if (res?.data && Array.isArray(res.data)) {
            const giftData = res.data;
            setGiftList(giftData);
            sessionStorage.setItem('giftList', JSON.stringify(giftData));
          } else {
            message.error('Không thể lấy danh sách quà tặng!');
          }
        } catch (error) {
          console.error('Lỗi khi lấy danh sách quà tặng:', error);
          message.error('Đã xảy ra lỗi khi lấy dữ liệu');
        }
      }
    };
  
    fetchGiftList();
  }, []);
  const handleTypeChangeSupplier = (value) => {
    // Lấy nhà cung cấp dựa vào loại xe đã chọn
    const selectedCar = cars.find(car => car.title === value);
    if (selectedCar) {
       orderForm.setFieldsValue({ supplier: selectedCar.type_supplier }); // Supplier is on orderForm
    }
  }

  // Khoi tao DOM cho calling ( Calling comp su dung react-rnd: Tranh viec Rnd nam tren 1 modal )
  useEffect(() => {
    callingContainerRef.current = document.createElement("div")
    document.body.appendChild(callingContainerRef.current)

    return () => {
      document.body.removeChild(callingContainerRef.current)
    }
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      type_verhicle_endow: form.getFieldValue("type_verhicle"),
      payload_endow: form.getFieldValue("payload"),
      number_seat_endow: form.getFieldValue("number_seat"),
      target_use_endow: form.getFieldValue("target_use"),
    })
  }, [form.getFieldValue("number_seat")])

  const getCars = () => {
    const cachedCars = sessionStorage.getItem('listCar');
    if (cachedCars) {
      setCars(JSON.parse(cachedCars));
    } else {
      CRMService.getCars()
        .then(res => {
          const carList = res?.success || [];
          setCars(carList);
          sessionStorage.setItem('listCar', JSON.stringify(carList));
        })
        .catch(err => console.error('Error fetching cars for ContactCustomer:', err));
    }
  };
 const getProvince = () => {
    if (listProvince.length > 0) return
    CRMService.getProvince()
      .then(res => {
        dispatch(setListProvince(res?.success))
        // setProvinces(res?.success);
      })
      .catch(err => console.error("get province err", err))
  }

  const getDistrict = provinceId => {
    CRMService.getDistrict({ province_id: provinceId })
      .then(res => {
        setDistrict(res?.success)
      })
      .catch(err => console.error("get district err", err))
  }

  const getWard = districtId => {
    CRMService.getWard({ district_id: districtId })
      .then(res => {
        setWard(res?.success)
      })
      .catch(err => console.error("get ward err", err))
  }

  const handleButtonClick = () => {
    const phoneNumber = dataContact?.phone_number

    if (Object.keys(dataContact).length === 0) {
      Notice({
        isSuccess: false,
        msg: "Không lấy được thông tin liên hệ. Vui lòng thử lại!",
      })
      return
    }
    if (/[a-zA-Z]/.test(phoneNumber) || /^\d{11}$/.test(phoneNumber)) {
      Notice({
        isSuccess: false,
        msg: "Số điện thoại không hợp lệ!",
      })
      return
    }
    dispatch(
      setInit({
        phoneNumber,
        data: { callType: CALL_TYPE.CALL_OUTBOUND },
        callType: CALL_TYPE.CALL_OUTBOUND,
      }),
    )
    // setIsComponentVisible(prev => !prev);
  }

  const handleChangeMoney = (e, field) => {
    const { value } = e.target
    const formattedValue = formatCurrency(value)
    orderForm.setFieldsValue({ [field]: formattedValue })
  }

  const getTotalPrice = (
    duration = 12,
    isOrderInfo = false,
    isBreak = false,
  ) => {
    if (isBreak) return
    const vehicleInfoForCheck = form.getFieldsValue()
    const payloadForCheck =
      vehicleInfoForCheck.payload_endow ?? dataContact?.load_capacity
    // if (!isOrderInfo && !isNumber(payloadForCheck)) {
    //   setIsPrioritize(false)
    //   return
    // }

    const vehicleInfo = form.getFieldsValue()
    const orderInfo = orderForm.getFieldValue();
    const currentStartDate = dayjs(orderForm.getFieldValue("start_date")).format('YYYY-MM-DD');
    const supplierOrder = orderInfo?.supplier || "";
    const payload = {
      type: vehicleInfo.type_verhicle_endow || dataContact?.vehicle_type,
      load_capacity:
        Number(vehicleInfo.payload_endow) ||
        Number(dataContact?.load_capacity) ||
        0,
      number_of_seats:
        Number(vehicleInfo.number_seat_endow) ||
        Number(dataContact?.number_of_seats),
      usage_purpose: vehicleInfo.target_use_endow ?? dataContact?.usage_purpose,
      duration,
      start_date: currentStartDate,
      end_date: dayjs(currentStartDate).add(duration, "month").format('YYYY-MM-DD'),
      supplier: orderInfo?.supplier || "",
    }
    if(!payload.type || !payload.number_of_seats || !payload.duration) return
    if (supplierOrder !== "PVI") {
      delete payload.start_date;
      delete payload.end_date;
    }
    setIsEndowCalculated(false)
    CRMService.totalPrice(payload)
      .then(res => {
        const { message } = res
        if (!message?.fee_including_vat) {
        throw new Error("Không tính được giá");
        }
        const vehicleType = payload.type;

        const finalPrice = applyTrainingVehiclePrice(
          message?.fee_including_vat,
          vehicleType
        );
        const discount20 = applyTrainingVehiclePrice(
          message?.discount_20,
          vehicleType
        );
        const discount25 = applyTrainingVehiclePrice(
          message?.discount_25,
          vehicleType
        );
        const discount30 = applyTrainingVehiclePrice(
          message?.discount_30,
          vehicleType
        );
         // ✅ API thành công → hợp lệ
        setIsEndowCalculated(true);
        !isOrderInfo && setIsPrioritize(true)
        if (isOrderInfo) {
          orderForm.setFieldsValue({
            price: formatCurrency(finalPrice.toString()),
          })
        } else {
          form.setFieldsValue({
            price_prioritize: formatCurrency(
              finalPrice?.toString(),
            ),
            price_discount_20: formatCurrency(discount20?.toString()),
            price_discount_25: formatCurrency(discount25?.toString()),
            price_discount_30: formatCurrency(discount30?.toString()),
          })
          orderForm.setFieldsValue({price:formatCurrency(
            finalPrice?.toString(),
          )})
        }
      })
      .catch(err => {
        !isOrderInfo && setIsPrioritize(false)
        console.error("err", err)
        setIsEndowCalculated(false);
      })
      .finally(() => {
        !isOrderInfo && setIsFetchedPrioritize(true)
      })
  }

  const createOrder = payload => {
    // if (!isEndowCalculated) {
    //     notification.warning({
    //         message: "Lỗi tính giá",
    //         description: "Vui lòng tính giá ưu đãi trước khi tạo đơn",
    //     });
    //     setIsLoading(false);
    //     return;
    // }
    const data = {
      ...payload,
      phone: /^\d+$/.test(payload.phone)
        ? payload.phone
        : dataContact.phone_number,

    }
    HRService.orderCreate(data)
      .then(res => {
        onCancel()
        dispatch(updateStatus({ contactId, status: 4 }))
        // getListContact();
        Notice({ msg: "Tạo đơn hàng thành công!", isSuccess: true })
      })
      .catch(err => {
        console.log(err, "err");
        Notice({ msg: err.response?.data?.message || "Tạo đơn hàng thất bại!", isSuccess: false })
      })
      .finally(() => setIsLoading(false))
  }

  const updateContact = (contactId, updatePayload) => {
    setIsLoading(true)
    HRService.updateContactStatus(contactId, updatePayload)
      .then(async res => {
        if (Number(statusResult) !== 4) {
          Notice({ msg: "Cập nhật thành công!", isSuccess: true })
          dispatch(updateStatus({ contactId, ...updatePayload }))
          // getListContact()
          onCancel()
          return
        }
        try {
          const customerId = res?.success?.customer_id
          const orderValues = orderForm.getFieldsValue()
          const formContact = form.getFieldsValue()
          const payload = {
            ...orderValues,
            customer_id: customerId,
            duration: orderValues.duration.toString(),
            start_date: dayjs(orderValues.start_date).format("YYYY-MM-DD"),
            end_date: dayjs(orderValues.expiry_date).format("YYYY-MM-DD"),
            price: orderValues?.price?.replace(/,/g, ""),
            price_discount: orderValues?.price_discount?.replace(/,/g, ""),
            price_backseat: orderValues?.price_backseat?.replace(/,/g, ""),
            price_body: orderValues?.price_body?.replace(/,/g, ""),
            contact_id: contactId,
            province_id: Number(orderValues.province_id),
            district_id: Number(orderValues.district_id),
            ward_id: Number(orderValues.ward_id),
            home: orderValues.shipping_address,
            vehicle_type: formContact?.type_verhicle || dataContact?.vehicle_type,
            usage_purpose: String(formContact?.target_use_endow) || dataContact?.usage_purpose,
            load_capacity: Number(formContact.payload_endow) || Number(dataContact?.load_capacity) || 0,
            number_of_seats: Number(formContact.number_seat_endow) || Number(dataContact?.number_of_seats) || 0,
          }
          payload.HDDT = !!orderValues.HDDT
          if (payload.HDDT) {
            payload.TenKHVAT = orderValues.TenKHVAT || null
            payload.MaSoVAT = orderValues.MaSoVAT || null
            payload.DiaChiVAT = orderValues.DiaChiVAT || null
            payload.EmailKH = orderValues.EmailKH || null
            payload.TTinHDDT = orderValues.TTinHDDT || null
          } else {
            payload.HDDT = false
            delete payload.TenKHVAT
            delete payload.MaSoVAT
            delete payload.DiaChiVAT
            delete payload.EmailKH
            delete payload.TTinHDDT
          }
          delete payload.expiry_date
          createOrder(payload)
        } catch (err) {
          Notice({
            msg: "Đã xảy ra lỗi. Vui lòng liên hệ QTV",
            isSuccess: false,
          })
          console.error("OBJ ERR:", err)
        }
      })
      .catch(err => {
        Notice({ msg: "Liên hệ cần được assign", isSuccess: false })
        console.error("update status err", err)
      })
      .finally(() => Number(statusResult) !== 4 && setIsLoading(false))
  }

  const handleSubmit = async () => {
    if (!permissions.includes("contact.updateStatus")) {
      Notice({
        msg: "Bạn không có quyền thực hiện hành động này!",
        isSuccess: false,
      })
      return
    }

    try {
      const values = await orderForm.validateFields()
      const payload = { status: values.status_call, desc: values.desc }
      if (statusResult === 2) {
        delete payload.callbackDay
        payload.callback_date = dayjs(values.callback_date).format("YYYY-MM-DD")
      }
      if (Number(statusResult) === 4) delete payload.desc
      await updateContact(contactId, payload)
    } catch (err) {
      form.scrollToField("price_discount", {
        behavior: "smooth",
        block: "center",
      })
      console.error("form error:", err)
    }
  }

  useEffect(() => {
    getCars()
  }, [])

const handleDurationChange = (selectedDuration) => {
  // Đồng bộ các trường thời hạn bảo hiểm trên cả hai form
  form.setFieldsValue({
    duration_prioritize: selectedDuration,
    duration_prioritize_endow: selectedDuration
  });
  orderForm.setFieldsValue({ duration: selectedDuration });

  // Lấy ngày bắt đầu hiện tại từ orderForm
  const currentStartDate = orderForm.getFieldValue("start_date");

  // Đảm bảo currentStartDate là một đối tượng dayjs hợp lệ
  // Nếu không hợp lệ (ví dụ: undefined, null, hoặc chuỗi không đúng định dạng),
  // sẽ mặc định là ngày hiện tại để tránh lỗi tính toán
  const validStartDate = dayjs.isDayjs(currentStartDate) && currentStartDate.isValid()
    ? currentStartDate
    : dayjs(); // Fallback an toàn nếu start_date chưa được thiết lập hoặc không hợp lệ

  // Tính toán và cập nhật ngày hết hạn
  const expiryDate = validStartDate.add(selectedDuration, "month");
  orderForm.setFieldsValue({ expiry_date: expiryDate });

  // Luôn gọi tính toán lại giá, bất kể từ trường nào
  getTotalPrice(selectedDuration, false); // offer
  if (Number(statusResult) === 4) {
    getTotalPrice(selectedDuration, true); // order
  }
    calculateBackseatPriceInOrder();
};

useEffect(() => {
  if (statusResult === 4 && dataContact && Object.keys(dataContact).length > 0) {
    let consistentDuration = orderForm.getFieldValue('duration');
    if (consistentDuration === undefined || consistentDuration === null) {
      consistentDuration = form.getFieldValue('duration_prioritize_endow');
    }
    if (consistentDuration === undefined || consistentDuration === null) {
      consistentDuration = dataContact.data_price?.duration || 12; // Lấy từ data_price nếu có, hoặc default
    }

    // Đồng bộ lại duration cho cả 3 trường nếu chưa khớp
    if (form.getFieldValue('duration_prioritize_endow') !== consistentDuration) {
      form.setFieldsValue({ duration_prioritize_endow: consistentDuration });
    }
    if (form.getFieldValue('duration_prioritize') !== consistentDuration) {
      form.setFieldsValue({ duration_prioritize: consistentDuration });
    }
    // orderForm.duration đã được ưu tiên ở trên, nếu nó có giá trị thì consistentDuration sẽ là nó.
    // Nếu orderForm.duration chưa có, nó sẽ được set ở đây.
    if (orderForm.getFieldValue('duration') !== consistentDuration) {
         orderForm.setFieldsValue({ duration: consistentDuration });
    }

    // Chỉ gọi getTotalPrice cho order nếu isFetchedPrioritize đã true (tránh gọi khi chưa có dữ liệu ưu đãi)
    if (isFetchedPrioritize) {
        getTotalPrice(consistentDuration, true); 
    }
      calculateBackseatPriceInOrder();

    const startDateForOrder = dataContact.renewal_date
      ? dayjs(dataContact.renewal_date) // Giả sử renewal_date là ngày bắt đầu của kỳ mới
      : dayjs(); // Mặc định là ngày hiện tại nếu không có

    orderForm.setFieldsValue({
      start_date: startDateForOrder,
      expiry_date: dayjs(startDateForOrder).add(consistentDuration, "month"),
      name: dataContact?.full_name || "",
      phone: dataContact?.phone_number ? maskPhoneNumber(dataContact?.phone_number) : "",
      shipping_address: dataContact?.shipping_address || dataContact?.address || "", // Ưu tiên shipping_address nếu có
      kind : dataContact?.kind || 0,
    });

    // Cập nhật nhà cung cấp cho orderForm dựa trên loại xe đã chọn trong phần ưu đãi
    const vehicleTypeForSupplier = form.getFieldValue('type_verhicle_endow') || dataContact?.vehicle_type;
    if (vehicleTypeForSupplier) {
        const selectedCar = cars.find(car => car.title === vehicleTypeForSupplier);
        if (selectedCar && selectedCar.supplier) {
            orderForm.setFieldsValue({ supplier: selectedCar.supplier });
        }
    }

    // Xử lý địa chỉ giao hàng từ shippingDataRef
    if (shippingDataRef.current && Object.keys(shippingDataRef.current).length > 0) {
      const { province_id, district_id, ward_id } = shippingDataRef.current;
      handleFillDataOrder(province_id, district_id, ward_id);
    }
  }
}, [statusResult, dataContact, cars, isFetchedPrioritize]); // Thêm isFetchedPrioritize

 const handleFillDataOrder = (province_id, district_id, ward_id) => {
    const data = [
      {
        id: province_id,
        action: getProvince,
        key: "province_id",
        nextAction: getDistrict,
      },
      {
        id: district_id,
        action: () => {},
        key: "district_id",
        parentId: province_id,
        nextAction: getWard,
      },
      { id: ward_id, action: () => {}, key: "ward_id", parentId: district_id },
    ]

    data.forEach(({ id, action, key, parentId, nextAction }) => {
      if (id) {
        action(parentId)
        orderForm.setFieldsValue({ [key]: id.toString() })
        if (nextAction) nextAction(id)
      }
    })
  }

  const handleCalculateEndow = async () => {
    setIsFetchedPrioritize(false)
    setStatusResult(4)
    orderForm.setFieldsValue({ status_call: 4 })

    const values = await form.validateFields()
    const payload = {
      duration: values.duration_prioritize_endow,
      load_capacity: Number(values.payload_endow) || 0,
      number_of_seats: Number(values.number_seat_endow),
      type: values.type_verhicle_endow,
      usage_purpose: values.usage_purpose_endow,
    }
    CRMService.totalPrice(payload)
      .then(res => {
        const { message } = res
        setIsPrioritize(true)
        orderForm.setFieldsValue({
          price: formatCurrency(message?.fee_including_vat?.toString()),
          duration: message.duration,
        })
        form.setFieldsValue({
          duration_prioritize: message.duration,
          price_prioritize: formatCurrency(
            message?.fee_including_vat?.toString(),
          ),
          price_discount_20: formatCurrency(message?.discount_20?.toString()),
          price_discount_25: formatCurrency(message?.discount_25?.toString()),
          price_discount_30: formatCurrency(message?.discount_30?.toString()),
        })
      })
      .catch(err => {
        setIsPrioritize(false)
        console.error("err", err)
      })
      .finally(() => {
        setIsFetchedPrioritize(true)
      })
  }

  useEffect(() => {
    const fetchData = async () => {
      if (Object.keys(dataContact).length === 0 && contactId) {
        try {
          const res = await HRService.getContactDetail(contactId)
          const { success } = res
          const { shipping, data_price } = success

          setDataContact(success)
          form.setFieldsValue({
            time_extend: success.renewal_date
              ? dayjs(success.renewal_date)
              : undefined,
            type_verhicle: success.vehicle_type,
            brand: success.brand,
            type: success.type,
            license_plate: success.license_plate,
            target_use: Number(success.usage_purpose),
            number_seat: success.number_of_seats,
            payload: success.load_capacity,
            machine_number: success.engine_number,
            frame_number: success.chassis_number,
            name: success.full_name,
            phone_number: success.phone_number,
            address: success.address,
            province: success.provinces?.title,
            price_info: success?.price
              ? formatCurrency(parseFloat(success?.price)?.toString())
              : "",
            shipping_address_info: success.shipping_address,
            assigned: success?.assigned?.personnel?.name || "",
          })

          if (data_price && Object.keys(data_price).length > 0) {
            if (isNumber(success?.load_capacity)) {
              form.setFieldsValue({
                price_prioritize: formatCurrency(
                  data_price?.fee_including_vat?.toString(),
                ),
                price_discount_20: formatCurrency(
                  data_price?.discount_20?.toString(),
                ),
                price_discount_25: formatCurrency(
                  data_price?.discount_25?.toString(),
                ),
                price_discount_30: formatCurrency(
                  data_price?.discount_30?.toString(),
                ),
                duration_prioritize_endow: data_price?.duration,
                type_verhicle_endow: success?.vehicle_type,
                payload_endow: success?.load_capacity,
                number_seat_endow: success?.number_of_seats,
                target_use_endow: success?.usage_purpose
                  ? Number(success?.usage_purpose)
                  : null,
              })
              setIsPrioritize(true)
            }
          }

          shippingDataRef.current = shipping
          if (success.callback_date) {
            const now = dayjs()
            const daysDiff = dayjs(success.callback_date).diff(now, "day") + 1
            orderForm.setFieldsValue({
              callbackDay: daysDiff.toString(),
              callback_date: success.callback_date
                ? dayjs(success.callback_date)
                : undefined,
            })
          }
          orderForm.setFieldsValue({
            status_call: success.status,
            desc: success.desc,
          })
          setStatusResult(success.status)
        } catch (err) {
          console.log("Error fetching contact detail:", err)
        } finally {
          setIsFetchedPrioritize(true)
        }
      }
       if (
        shippingDataRef.current &&
        Object.keys(shippingDataRef.current).length > 0 &&
        statusResult === 4
      ) {
        const { province_id, district_id, ward_id } = shippingDataRef.current
        handleFillDataOrder(province_id, district_id, ward_id)
      }
    }
    fetchData().then()
  }, [contactId])

  const isNumber = val => {
    if (typeof val === "string" && isNaN(val)) return false
    return true
  }

  useEffect(() => {
    const payload = form.getFieldValue('payload');
    if (typeof payload === 'string' && !isNumber(payload)) {
      setShowSelect(true);  // Không phải số => hiện Select
    } else {
      setShowSelect(false); // Là số => hiện Input (disabled)
    }
  }, [form.getFieldValue('payload')]);


  // Hàm tính giá người ngồi sau cho form order
const calculateBackseatPriceInOrder = () => {
    const typeBackseat = orderForm.getFieldValue("type_backseat"); // Giá trị là 1 hoặc 2
    const numberOfSeatsString = dataContact?.number_of_seats; // Lấy từ dataContact
    const durationInMonthsString = orderForm.getFieldValue("duration"); // Số tháng (12, 18, 24, 36)
    const supplier = orderForm.getFieldValue("supplier"); // Lấy nhà cung cấp từ orderForm

    const seatCount = parseInt(numberOfSeatsString, 10);
    const durationInMonths = parseInt(durationInMonthsString, 10);

    if (typeBackseat && !isNaN(seatCount) && seatCount > 0 && !isNaN(durationInMonths) && durationInMonths > 0) {
      if (typeBackseat > 0) {
        const actualSeatCountForBackseat = seatCount > 0 ? seatCount : 0;
       
        const selected = BACKSEAT_BASE_AMOUNT_OPTIONS.find(
          (item) => item.value === typeBackseat
        );

        const priceBackseat = selected?.priceBackseat || 0;
        // const calculatedPrice = basePricePerSeatPerYear * actualSeatCountForBackseat * durationInYears;
        console.log("data contact:", priceBackseat, actualSeatCountForBackseat, durationInMonths, supplier);
        const calculatedPrice = calculateBackseatPrice({baseAmount: priceBackseat, seatCount: actualSeatCountForBackseat, durationInMonths: durationInMonths, supplier: supplier});
       const safePrice = Number.isFinite(calculatedPrice)
        ? Math.round(calculatedPrice)
        : 0;

        orderForm.setFieldsValue({
          price_backseat: formatCurrency(String(safePrice))
        });
      } else {
        orderForm.setFieldsValue({ price_backseat: "" });
      }
    } else {
      orderForm.setFieldsValue({ price_backseat: "" });
    }
  };
  return (
    <div style={{ marginBottom: 50 }}>
      <ConfigProvider
        theme={{
          token: {
            colorTextDisabled: "black",
          },
        }}
      >
        <Form
          form={form}
          labelCol={{ span: 9 }}
          wrapperCol={{ span: 14 }}
          layout="horizontal"
          labelAlign="left"
          initialValues={{ duration_prioritize: 12 }}
        >
          {isCalling && (
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="assigned" label="Sale quản lý:">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
          )}
          <BlockInfoStyle>
            <TextTileStyle>Thông tin xe</TextTileStyle>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="time_extend" label="Ngày gia hạn">
                  <DatePicker disabled format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="license_plate" label="Biển kiểm soát">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="type_verhicle" label="Loại xe">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="brand" label="Nhãn hiệu">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="type" label="Hiệu xe">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="frame_number" label="Số khung">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="machine_number" label="Số máy">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>              
            {/*      <Form.Item name="payload" label="Trọng tải">*/}
            {/*  {showSelect ? (*/}
            {/*    <AutoComplete*/}
            {/*      options={options}*/}
            {/*      placeholder="Nhập hoặc chọn trọng tải"*/}
            {/*      filterOption={(inputValue, option) =>*/}
            {/*        option?.label.toLowerCase().includes(inputValue.toLowerCase())*/}
            {/*      }*/}
            {/*      allowClear*/}
            {/*    />*/}
            {/*  ) : (*/}
            {/*    <Input maxLength={255} disabled />*/}
            {/*  )}*/}
            {/*</Form.Item>*/}
                <Form.Item name="payload" label="Trọng tải">
                  <Input maxLength={255} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="number_seat" label="Số chỗ">
                  <Input maxLength={255} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
              <Form.Item label="Mục đích sử dụng">
            <Form.Item noStyle shouldUpdate>
              {() => {
                const selectedId = form.getFieldValue("target_use");
                const selectedTitle = Object.values(INTENDED_USE).find(
                  item => Number(item.id) === Number(selectedId)
                )?.title;

                return <Input disabled value={selectedTitle || ""} />;
              }}
            </Form.Item>
          </Form.Item>
              </Col>
            </Row>
          </BlockInfoStyle>
          <BlockInfoStyle>
            <TextTileStyle>Thông tin khách hàng</TextTileStyle>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="name" label="Tên khách hàng">
                  <Input disabled />
                </Form.Item>
              </Col>
              {/* <Col span={12}>
                <Form.Item name="address" label="Địa chỉ">
                  <Input disabled />
                </Form.Item>
              </Col> */}
              <Col span={12}>
                <Form.Item name="address" label="Địa chỉ">
                  <span>{dataContact?.address}</span>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="province" label="Tỉnh">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="phone_number"
                  label="Số điện thoại"
                  valuePropName="phone_number"
                >
                  <div style={{ display: "flex" }}>
                    <Form.Item name="phone_number" noStyle>
                      <PhoneInputForm
                        name="phone_number"
                        form={form}
                        phoneNumber={form.getFieldValue("phone_number")}
                        canShowPhone={permissions.includes("contact.showPhone")}
                        disabled
                      />
                    </Form.Item>
                    {/* <div
                      onClick={() => {
                      const phone = form.getFieldValue("phone_number"); // Lấy số điện thoại
                      if (phone) {
                          navigator.clipboard.writeText(phone);
                          message.success("Đã copy số điện thoại!");
                      } else {
                          message.warning("Không có số điện thoại để copy!");
                      }
                      }}
                      style={{ cursor: "pointer", marginLeft: "5px" }}
                      >
                    <IconBase size="larger" name="copy" />
                    </div> */}
                    <div
                      onClick={() => {
                        const url = `https://zalo.me/${dataContact?.phone_number}`
                        window.open(url, "_blank", "width=500,height=600")
                        // window.location.href = `zalo://send?phone=${dataContact?.phone_number}`;
                      }}
                      style={{ cursor: "pointer", marginLeft: "5px" }}
                    >
                      <IconBase size="larger" name="zalo" />
                    </div>
                  </div>
                </Form.Item>
              </Col>
            </Row>
            {(type === "renewal" || type === "return") && (
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="price_info" label="Giá tiền đã bán">
                    <Input disabled suffix="vnđ" />
                  </Form.Item>
                </Col>
                {type === "renewal" && (<Col span={12}>
                  <Form.Item
                    name="shipping_address_info"
                    label="Địa chỉ nhận hàng"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>)}
              </Row>
            )}
            <Row gutter={16}>
              <Col
                span={24}
                className="d-flex justify-content-start"
                style={{ flexWrap: "wrap", gap: "10px" }}
              >
                <Button
                  disabled={callState !== CALL_STATE.UNAVAILABLE}
                  btnType="primary1"
                  onClick={handleButtonClick}
                  icon={<FaPhone />}
                >
                  Gọi
                </Button>
              </Col>
            </Row>
          </BlockInfoStyle>
          <BlockInfoStyle>
            <TextTileStyle>Thông tin ưu đãi</TextTileStyle>
            <Row gutter={16}>
              <Col span={8}>
           <Form.Item
          label="Thời gian bảo hiểm"
          name="duration_prioritize_endow"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <Select onChange={(value) => handleDurationChange(value)}>
            {EXPIRY_DATE.map(item => (
              <Select.Option key={item.id?.toString()} value={item.ID}>
                {item.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
            </Col>
              <Col span={8}>
                <Form.Item
                  label="Loại xe"
                  name="type_verhicle_endow"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[{ required: true, message: "Vui lòng chọn loại xe" }]}
                >
                  <Select
                    //  onClick={getCars}
                    // onSelect={handleTypeChangeSupplier}
                    style={{ height: "unset" }}
                    placeholder="Chọn loại xe"
                    onChange={value =>
                      {form.setFieldsValue({ type_verhicle: value });
                      getTotalPrice(form.getFieldValue('duration_prioritize_endow'), false);
                      }
                    }
                  >
                    {cars.map(item => (
                      <Select.Option
                        key={item.ID?.toString()}
                        value={item.title}
                      >
                        {item.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
              <Form.Item
                label="Trọng tải"
                name="payload_endow"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  { required: true, message: "Vui lòng nhập trọng tải" },
                  {
                    pattern: /^[0-9]*$/,
                    message: `Vui lòng nhập trọng tải hợp lệ`,
                  },
                  {
                    validator: (_, value) =>
                      !value || Number(value) <= 99999
                        ? Promise.resolve()
                        : Promise.reject("Trọng tải không được lớn hơn 99,999kg"),
                  },
                ]}
                extra="(Lưu ý: Việc nhập trọng tải không ảnh hưởng đến quá trình in đơn)"
              >
                <InputNumber
                  placeholder="Nhập trọng tải"
                  style={{ width: "100%" }}
                  suffix="kg"
                  onChange={() =>
                    getTotalPrice(form.getFieldValue("duration_prioritize_endow"), false)
                  }
                />
              </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Số chỗ"
                  name="number_seat_endow"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    { required: true, message: "Vui lòng nhập số chỗ" },
                    {
                      pattern: /^[0-9]*$/,
                      message: `Vui lòng nhập số chỗ hợp lệ`,
                    },
                    {
                      validator: (_, value) =>
                        !value || Number(value) <= 100
                          ? Promise.resolve()
                          : Promise.reject("Số chỗ không được vượt quá 100"),
                    },
                  ]}
                >
                  <InputNumber placeholder="Nhập số chỗ" style={{ width: '100%' }}
                    onChange={() => getTotalPrice(form.getFieldValue('duration_prioritize_endow'), false)}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Mục đích kinh doanh"
                  name="target_use_endow"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Select
                    onChange={() => getTotalPrice(form.getFieldValue('duration_prioritize_endow'), false)}
                  >
                    {Object.keys(INTENDED_USE).map(key => (
                      <Select.Option
                        key={INTENDED_USE[key].id?.toString()}
                        value={INTENDED_USE[key].id}
                      >
                        {INTENDED_USE[key].title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {isFetchedPrioritize ? (
              isPrioritize ? (
                <>
                  <div style={{ padding: "10px 0 5px", marginBottom: "15px" }}>
                    <span
                      style={{
                        color: "#0091c7",
                        borderBottom: "1px solid #0091c7",
                        fontWeight: "700",
                        padding: "3px",
                      }}
                    >
                      Kết quả
                    </span>
                  </div>
                  <Row gutter={16}>
                   <Col span={8}>
              <Form.Item
                label="Thời gian bảo hiểm"
                name="duration_prioritize"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Select onChange={(value) => handleDurationChange(value)}>
                  {EXPIRY_DATE.map(item => (
                    <Select.Option key={item.id?.toString()} value={item.ID}>
                      {item.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
                          </Col>
                    <Col span={10}>
                      <Form.Item
                        label="Giá cả VAT"
                        name="price_prioritize"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input suffix="vnđ" disabled={true} />
                      </Form.Item>
                    </Col>
                    <Col span={6} />
                  </Row>
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        label="Giá chiết khấu (10%)"
                        name="price_discount_20"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input suffix="vnđ" disabled={true} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Giá chiết khấu (15%)"
                        name="price_discount_25"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input suffix="vnđ" disabled={true} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Giá chiết khấu (20%)"
                        name="price_discount_30"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                      >
                        <Input suffix="vnđ" disabled={true} />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : (
                <div>Chưa có ưu đãi cho liên hệ này</div>
              )
            ) : (
              <p>Đang tải...</p>
            )}
          </BlockInfoStyle>
        </Form>
        <Form
          form={orderForm}
          layout="vertical"
          initialValues={{ duration: 12 }}
        >
          <BlockInfoStyle>
            <TextTileStyle>Kết quả</TextTileStyle>
            <Row gutter={16}>
              <Col span={10}>
                <Form.Item
                  name="status_call"
                  label="Trạng thái cuộc gọi"
                  rules={[
                    { required: true, message: "Vui lòng chọn trạng thái." },
                  ]}
                >
                  <Select
                    style={{ height: "unset" }}
                    placeholder="Chọn trạng thái"
                    onChange={v => setStatusResult(v)}
                    allowClear
                  >
                    {statusCall.map(item => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {statusResult === 2 && (
                <>
                  <Col span={7}>
                    <Form.Item
                      name="callback_date"
                      label="Ngày hẹn"
                      rules={[
                        { required: true, message: "Vui lòng nhập ngày hẹn." },
                      ]}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        onChange={date => {
                          if (date) {
                            const now = dayjs()
                            const daysDiff = date.diff(now, "day") + 1
                            orderForm.setFieldsValue({
                              callbackDay: daysDiff.toString(),
                            })
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      name="callbackDay"
                      label="Hẹn lại sau"
                      rules={[
                        {
                          pattern: /^[0-9,]*$/,
                          message: `Vui lòng nhập số ngày hợp lệ.`,
                        },
                      ]}
                    >
                      <Input
                        maxLength={3}
                        suffix="ngày"
                        onChange={e => {
                          const days = parseInt(e.target.value, 10)
                          if (!isNaN(days)) {
                            const newDate = dayjs().add(days, "day")
                            orderForm.setFieldsValue({
                              callback_date: dayjs(newDate),
                            })
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                </>
              )}

              {Number(statusResult) !== 4 && (
                <Col span={14}>
                  <Form.Item name="desc" label="Ghi chú">
                    <Input />
                  </Form.Item>
                </Col>
              )}
            </Row>
          </BlockInfoStyle>
          {Number(statusResult) === 4 && (
            <BlockInfoStyle>
              <TextTileStyle>Thông tin Đơn hàng</TextTileStyle>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Ngày bắt đầu"
                    name="start_date"
                    rules={[
                      { required: true, message: "Vui lòng nhập ngày bắt đầu!" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.resolve();
                          }
                          if (value.isBefore(dayjs().startOf('day'))) {
                            return Promise.reject(new Error("Ngày bắt đầu không được là ngày trong quá khứ!"));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <DatePicker
                      allowClear={false}
                      format="DD/MM/YYYY"
                      disabledDate={(current) => {
                          // Chặn các ngày trước hôm nay
                        return current && current < dayjs().startOf('day');
                       }}
                      onChange={val => {
                        const duration = orderForm.getFieldValue("duration")
                        if (duration === undefined) return
                        const expiry_date = dayjs(val).add(duration, "month")
                        orderForm.setFieldsValue({ expiry_date })
                        handleDurationChange(duration)
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
              <Form.Item
                label="Thời gian bảo hiểm"
                name="duration"
              >
                <Select onChange={(value) => handleDurationChange(value)}>
                  {EXPIRY_DATE.map(item => (
                    <Select.Option key={item.id?.toString()} value={item.ID}>
                      {item.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Ngày hết hạn" name="expiry_date">
                    <DatePicker   disabled={true} format="DD/MM/YYYY" />
                  </Form.Item>
                </Col>
              </Row>           
              <Row gutter={16}>
               <Col span={8}>
                <Form.Item
                  label="Nhà cung cấp"
                  name="supplier"
                  rules={[{ required: true, message: "Vui lòng chọn nhà cung cấp." }]}
                >
                  <Select
                    allowClear
                    style={{ height: 'unset' }}
                    placeholder="Chọn nhà cung cấp"
                     options={PROVIDER_OPTIONS.map(item => ({
                        label: item.label,
                        value: item.value,
                      }))}
                    onChange={() => {getTotalPrice(form.getFieldValue('duration_prioritize_endow'), false)
                        calculateBackseatPriceInOrder();
                      }
                    }
                  />
                </Form.Item>
              </Col>
                <Col span={8}>
                  <Form.Item
                    label="Giá cả VAT"
                    name="price"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập giá cả VAT!",
                      },
                      { validator: validateNoLettersOrSpecialChars },
                    ]}
                  >
                    <Input
                      disabled
                      suffix="vnđ"
                      onChange={e => handleChangeMoney(e, "price")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                 <Form.Item
                    label="Giá bán (COD)"
                    name="price_discount"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập giá bán (COD)!",
                      },
                      ({ getFieldValue }) => ({
                                            validator(_, value) {
                          const discount = parseInt((value || "").replace(/,/g, ""), 10);
                          const priceString = (getFieldValue("price") || "").replace(/,/g, "");                        
                          const price = parseInt(priceString, 10);

                          // Kiểm tra giá chiết khấu phải lớn hơn 100,000
                          if (value && !isNaN(discount) && discount <= 100000) {
                            return Promise.reject(new Error("Giá bán (COD) phải lớn hơn 100,000!"));
                          }
                          if (
                            priceString !== "" &&
                            !isNaN(price) &&
                            !isNaN(discount) &&
                            discount > price + 20000
                          ) {
                            return Promise.reject(
                              new Error("Giá bán (COD) không được lớn hơn Giá cả VAT 20.000!")
                            );
                          }
                          // if (priceString !== "" && !isNaN(price) && !isNaN(discount) && discount > price) { // Kiểm tra không lớn hơn giá niêm yết
                          //   return Promise.reject(new Error("Giá bán (COD) không được lớn hơn giá cả VAT!"));
                          // }
                              const priceBackseatString = (getFieldValue("price_backseat") || "").replace(/,/g, "");
                              const priceBackseat = parseInt(priceBackseatString, 10) || 0;

                              // const priceBodyString = (getFieldValue("price_body") || "").replace(/,/g, "");
                              // const priceBody = parseInt(priceBodyString, 10) || 0;

                              //         // Kiểm tra giá bán (COD) phải lớn hơn tổng price_backseat và price_body
                              // if (!isNaN(discount) && discount <= (priceBackseat + priceBody + price)) {
                              //   return Promise.reject(new Error("Giá bán (COD) phải lớn hơn tổng giá người ngồi sau xe, giá bảo hiểm thân vỏ và giá cả VAT!"));
                              //   }

                          return Promise.resolve();
                        },
                      }),
                      { validator: validateNoLettersOrSpecialChars },
                    ]}
                  >
                    <Input
                      suffix="vnđ"
                      onChange={e => handleChangeMoney(e, "price_discount")}
                    />
                  </Form.Item>
                </Col>
               
                <Col span={8}></Col>
              </Row>
                <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label="Loại người ngồi sau xe"
                    name="type_backseat"
                    // rules={[{ required: true, message: "Vui lòng chọn loại người ngồi sau xe" }]}
                  >
                    <Select
                      allowClear
                      placeholder="Chọn loại người ngồi sau xe"
                      options={BACKSEAT_BASE_AMOUNT_OPTIONS}
                      onChange={(value) => {
                        orderForm.setFieldsValue({ type_backseat: value });
                        calculateBackseatPriceInOrder();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Giá người ngồi sau xe"
                    name="price_backseat"
                    rules={[{ validator: validateNoLettersOrSpecialChars }]}
                  >
                    <Input
                      suffix="vnđ"
                      readOnly // Giá này có thể được tính tự động
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Giá bảo hiểm thân vỏ"
                    name="price_body"
                    rules={[
                      // {
                      //   required: true,
                      //   message: "Vui lòng nhập giá bảo hiểm thân vỏ!",
                      // },
                      { validator: validateNoLettersOrSpecialChars }
                    ]}
                  >
                    <Input
                      suffix="vnđ"
                      onChange={e => handleChangeMoney(e, "price_body")}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label="Tên chủ xe" name="name">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Số điện thoại"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập số điện thoại!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Quà tặng" name="gift_type">
                         <Select allowClear style={{ height: 'unset' }}>
                           {giftList.map(item => (
                             <Select.Option key={item.ID?.toString()} value={item.ID}>
                               {item.title}
                             </Select.Option>
                           ))}
                         </Select>
                       </Form.Item>
                </Col>
            <Col span={8}>         
             <Form.Item
              label="Loại thanh toán"
              name="kind"
            >
              <Select
                allowClear
                style={{ height: 'unset' }}
                placeholder="Chọn loại thanh toán"
              >
                {[
                  { ID: 0, title: "Tiền mặt", value: 0 },
                  { ID: 1, title: "Chuyển khoản", value: 1 },
                ].map(item => (
                  <Select.Option key={item.ID} value={item.value}>
                    {item.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <FormItemStyle
                    label="Tỉnh thành"
                    name="province_id"
                    rules={[
                      { required: true, message: "Vui lòng chọn tỉnh thành!" },
                    ]}
                  >
                    <Select
                      notFoundContent={
                        listProvince.length === 0 ? (
                          <div style={{ textAlign: "center", padding: "10px" }}>
                            <Spin size="small" color="gray" />
                          </div>
                        ) : null
                      }
                      onClick={getProvince}
                      showSearch
                      placeholder="Nhập tỉnh thành"
                      optionFilterProp="children"
                      filterOption={(input, option) => {
                        const source = removeVietnameseTones(option.children)
                        const target = removeVietnameseTones(input)
                        return source.includes(target)
                      }}
                      onChange={value => {
                        orderForm.setFieldsValue({ province_id: value })
                        orderForm.resetFields(["district_id", "ward_id"])
                        getDistrict(value)
                      }}
                    >
                      {listProvince?.length > 0 &&
                        listProvince.map(value => (
                          <Select.Option
                            key={value.title}
                            value={value?.ID?.toString()}
                          >
                            {formatAddress(value.title)}
                          </Select.Option>
                        ))}
                    </Select>
                  </FormItemStyle>
                </Col>
                <Col span={6}>
                  <FormItemStyle
                    label="Quận huyện"
                    name="district_id"
                    rules={[
                      { required: true, message: "Vui lòng chọn quận huyện!" },
                    ]}
                  >
                    <Select
                      disabled={!orderForm.getFieldValue("province_id")}
                      showSearch
                      placeholder="Nhập quận huyện"
                      optionFilterProp="children"
                      filterOption={(input, option) => {
                        const source = removeVietnameseTones(option.children)
                        const target = removeVietnameseTones(input)
                        return source.includes(target)
                      }}
                      onChange={value => {
                        orderForm.setFieldsValue({ district_id: value })
                        orderForm.resetFields(["ward_id"])
                        getWard(value)
                      }}
                    >
                      {district.length > 0 &&
                        district.map(value => (
                          <Select.Option
                            key={value.title}
                            value={value?.ID?.toString()}
                          >
                            {formatAddress(value.title)}
                          </Select.Option>
                        ))}
                    </Select>
                  </FormItemStyle>
                </Col>
                <Col span={6}>
                  <FormItemStyle
                    label="Xã phường"
                    name="ward_id"
                    rules={[
                      { required: true, message: "Vui lòng chọn xã phường!" },
                    ]}
                  >
                    <Select
                      disabled={!orderForm.getFieldValue("district_id")}
                      showSearch
                      placeholder="Nhập xã phường"
                      optionFilterProp="children"
                      filterOption={(input, option) => {
                        const source = removeVietnameseTones(option.children)
                        const target = removeVietnameseTones(input)
                        return source.includes(target)
                      }}
                      onChange={value => {
                        form.setFieldsValue({ ward_id: value.toString() })
                      }}
                    >
                      {ward.length > 0 &&
                        ward.map(value => (
                          <Select.Option
                            key={value.title}
                            value={value?.ID?.toString()}
                          >
                            {formatAddress(value.title)}
                          </Select.Option>
                        ))}
                    </Select>
                  </FormItemStyle>
                </Col>
                <Col span={6} />
              </Row>
              <Row>
                <Col span={12}>
                  <Form.Item
                    label={
                      <span>
                        Địa chỉ nhận hàng{" "}
                        <span
                          style={{
                            fontSize: "12px",
                            fontStyle: "italic",
                            color: "gray",
                          }}
                        >
                          (Số nhà, thôn, xóm ...)
                        </span>
                      </span>
                    }
                    name="shipping_address"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập địa chỉ nhận hàng!",
                      },
                      {max: 100, message: "Địa chỉ không được vượt quá 100 ký tự!"}
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12} />
              </Row>
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item label="Ghi chú" name="desc">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>
                <Col span={8} />
              </Row>
            </BlockInfoStyle>
          )}

          {Number(statusResult) === 4 && (
            <BlockInfoStyle>
              <TextTileStyle>Thông tin Hóa đơn điện tử (VAT)</TextTileStyle>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="HDDT" valuePropName="checked" style={{ marginBottom: isHddt ? 16 : 0 }}>
                    <Checkbox
                      checked={isHddt}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setIsHddt(checked);
                        if (!checked) {
                          orderForm.setFieldsValue({
                            TenKHVAT: undefined,
                            MaSoVAT: undefined,
                            DiaChiVAT: undefined,
                            EmailKH: undefined,
                            TTinHDDT: undefined,
                          });
                        }
                      }}
                    >
                      Khách hàng có yêu cầu xuất hóa đơn điện tử (VAT)
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              {isHddt && (
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="TenKHVAT"
                      label={
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                          <span>Tên đơn vị / Khách hàng (VAT)</span>
                          <span
                            style={{ color: '#0091c7', cursor: 'pointer', fontSize: 12 }}
                            onClick={() => {
                              const fullName = orderForm.getFieldValue('name') || dataContact?.full_name;
                              if (fullName) orderForm.setFieldsValue({ TenKHVAT: fullName });
                            }}
                          >
                            (Lấy theo tên KH)
                          </span>
                        </div>
                      }
                    >
                      <Input placeholder="Ví dụ: CÔNG TY TNHH ABC hoặc NGUYỄN VĂN A" />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="MaSoVAT"
                      label="Mã số thuế (MST)"
                    >
                      <Input placeholder="Nhập mã số thuế (10 hoặc 13 số)" maxLength={50} />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="DiaChiVAT"
                      label={
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                          <span>Địa chỉ xuất hóa đơn</span>
                          <span
                            style={{ color: '#0091c7', cursor: 'pointer', fontSize: 12 }}
                            onClick={() => {
                              const addr = orderForm.getFieldValue('shipping_address') || dataContact?.shipping_address || dataContact?.address;
                              if (addr) orderForm.setFieldsValue({ DiaChiVAT: addr });
                            }}
                          >
                            (Lấy theo địa chỉ KH)
                          </span>
                        </div>
                      }
                    >
                      <Input placeholder="Địa chỉ theo ĐKKD hoặc MST" />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="EmailKH"
                      label="Email nhận hóa đơn"
                      rules={[{ type: 'email', message: 'Email không đúng định dạng!' }]}
                    >
                      <Input placeholder="ketoan@congty.com" />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      name="TTinHDDT"
                      label="Nội dung / Ghi chú ghi trên hóa đơn"
                    >
                      <Input.TextArea rows={2} placeholder="Nội dung hàng hóa/dịch vụ hoặc ghi chú thêm trên hóa đơn..." />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </BlockInfoStyle>
          )}
        </Form>
        <FooterStyle>
          <Button
            disabled={callState !== CALL_STATE.UNAVAILABLE}
            btnType="default"
            style={{ marginRight: 10 }}
            className="btn-hover-shadow"
            onClick={() => {
              onCancel && onCancel()
            }}
          >
            Hủy bỏ
          </Button>
          <Button
            disabled={
              (dataContact?.status === 6 && statusResult === 6) || isLoading
            }
            style={{ minWidth: "76px" }}
            btnType="primary"
            className="btn-hover-shadow"
            onClick={handleSubmit}
          >
            {isLoading ? (
              <LoadingOutlined />
            ) : Number(statusResult) === 4 ? (
              "Tạo đơn"
            ) : (
              "Cập nhật"
            )}
          </Button>
        </FooterStyle>
        {/*{isComponentVisible && dataContact?.phone_number && (*/}
        {/*    ReactDOM.createPortal(*/}
        {/*        <Calling setIsComponentVisible={setIsComponentVisible} phoneNumber={dataContact?.phone_number} />,*/}
        {/*        callingContainerRef.current*/}
        {/*    ))}*/}
      </ConfigProvider>
    </div>
  )
}

export default ContactCustomer
